import type { Profile } from '@mr-website/schemas';
import { Country } from 'country-state-city';

export interface InquiryContactAuthData {
  email: string | null;
  firstName: string | null;
  lastName: string | null;
}

export interface InquiryContactDefaults {
  first_name: string;
  last_name: string;
  email: string;
  phone_number?: string;
  phone_number_country_code?: string;
}

const phoneCandidates = (profile: Profile) => [
  { phone: profile.phone_mobile, country: profile.phone_mobile_country_code },
  { phone: profile.phone_work, country: profile.phone_work_country_code },
  { phone: profile.phone_other, country: profile.phone_other_country_code },
];

function resolveCountryCodeFromAddress(profile: Profile): string | undefined {
  const countryName = profile.home_address?.country;
  if (!countryName) return undefined;

  return Country.getAllCountries().find((country) => country.name === countryName)?.isoCode;
}

function resolvePhoneFromProfile(
  profile?: Profile,
): Pick<InquiryContactDefaults, 'phone_number' | 'phone_number_country_code'> {
  if (!profile) return {};

  for (const { phone, country } of phoneCandidates(profile)) {
    if (phone?.trim()) {
      return {
        phone_number: phone.trim(),
        phone_number_country_code: country ?? resolveCountryCodeFromAddress(profile),
      };
    }
  }

  return {};
}

export function getInquiryContactDefaults(
  auth: InquiryContactAuthData,
  profile?: Profile,
): Record<string, unknown> {
  const phoneDefaults = resolvePhoneFromProfile(profile);

  return {
    first_name: profile?.first_name?.trim() || auth.firstName?.trim() || '',
    last_name: profile?.last_name?.trim() || auth.lastName?.trim() || '',
    email: profile?.email_address?.trim() || auth.email?.trim() || '',
    ...phoneDefaults,
  };
}
